import { render } from "./Heros.vue?vue&type=template&id=1c51688a"
const script = {}
script.render = render

export default script